import { useLocation } from "react-router";

export default function useCurrentLocation(): string {
  return useLocation().pathname.replace(/(.*)\/+$/, "$1");
}
